<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/factory/topic_icon.svg" />
      <h1>Manufacturing Plants</h1>
      <p>
        Hygienically manage the manufacturing process to
        <br />
        safeguard against pests, viruses, and bacteria.
      </p>
      <div class="topic-tags">
        <span class="tag"> #Manufacturing Plants <br class="mo_show" />(Glass, Paper, Steel Plates, etc.) </span>
      </div>
    </section>

    <img
      :src="require(`@/assets/images/location/factory/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [BusinessSectors] Manufacturing Plants"
    />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_defectrates.svg" alt="CESCO [BusinessSectors] Manufacturing Plants" />
            <div class="title">
              <h3>Management of Defect Rates Due to Foreign Materials</h3>
            </div>
            <p class="description">
              I am concerned about the production of defective products due to contamination from pests and foreign materials during the manufacturing
              process.
            </p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_rats.svg" alt="CESCO [BusinessSectors] Manufacturing Plants" />
            <div class="title">
              <h3>Concerns About Safety Accidents Caused by Rats</h3>
            </div>
            <p class="description">I am worried about safety incidents, such as fires caused by short circuits resulting from mice damaging wires.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_virus.svg" alt="CESCO [BusinessSectors] Manufacturing Plants" />
            <div class="title">
              <h3>Professional Virus Management</h3>
            </div>
            <p class="description">As the manufacturing process occurs in enclosed spaces, the spread of viral infections is a concern.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>Address both hygiene issues caused by various pests and potential secondary damages.</h4>
            <p>
              We provide education and management strategies to prevent and address secondary damage types, such as fires caused by rodent-damaged
              wires.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/factory/border_content_01.png" alt="CESCO [BusinessSectors] Manufacturing Plants" />
          </div>
          <div>
            <img src="@/assets/images/location/factory/border_content_02.png" alt="CESCO [BusinessSectors] Manufacturing Plants" />
          </div>
          <div class="border-content">
            <h4>Consider essential aspects of manufacturing plants carefully and manage them systematically and transparently.</h4>
            <p>
              Offer practical solutions including the identification of pest control chemicals used, their impact on the manufacturing process,
              regular hygiene management practices, and responsibility assignment in the event of a pest incident.
            </p>
          </div>
          <div class="border-content">
            <h4>Ensure the health and hygiene of your employees through CESCO’s systematic management.</h4>
            <p>
              For manufacturing plants where adherence to manufacturing schedules is critical, managing employee hygiene is essential. Prevent
              potential outbreaks of viruses and food poisoning with CESCO to enhance your manufacturing facility's competitiveness.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/factory/border_content_03.png" alt="CESCO [BusinessSectors] Manufacturing Plants" />
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="CESCO [BusinessSectors] Manufacturing Plants" />

          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="CESCO [BusinessSectors] Manufacturing Plants" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Manufacturing Plants
      </h3>

      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="CESCO [BusinessSectors] Manufacturing Plants" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_fly.svg" alt="CESCO [BusinessSectors] Manufacturing Plants" />
          <div class="content">
            <div>
              <div class="title">
                <h3>Flying Pest Control Solution</h3>
              </div>
              <p class="description">Managing stray pests such as flies, fruit flies, and sandflies</p>
            </div>

            <router-link to="/solution/service/fly"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="CESCO [BusinessSectors] Manufacturing Plants" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>

            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/factory/background_img_01.png'),
    products: [
      {
        posX: '37.5rem',
        posY: '28.1825rem',
        mobilePosX: '52%',
        mobilePosY: '72%',
        productInfo: {
          image: require('@/assets/images/location/factory/product_img_01.png'),
          name: 'CESCO\nSmart Indoor Rodent Control Equipment Viper',
          description: 'Hygienically captures rats that enter business premises and monitors their movement and habitation with smart technology.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/factory/background_img_02.png'),
    products: [
      {
        posX: '19.125rem',
        posY: '11.4325rem',
        mobilePosX: '26%',
        mobilePosY: '34%',
        productInfo: {
          image: require('@/assets/images/location/factory/product_img_02.png'),
          name: 'CESCO\nIndoor Insect Light Phoenix',
          description: 'Effectively attracts and captures stray pests within business premises.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/factory/background_img_03.png'),
    products: [
      {
        posX: '53.25rem',
        posY: '10.5575rem',
        mobilePosX: '70%',
        mobilePosY: '30%',
        productInfo: {
          image: require('@/assets/images/location/factory/product_img_03.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/factory/background_img_04.png'),
    products: [
      {
        posX: '27.4375rem',
        posY: '22.9325rem',
        mobilePosX: '37%',
        mobilePosY: '68%',
        productInfo: {
          image: require('@/assets/images/location/factory/product_img_04.png'),
          name: 'CESCO\nWater Stand-type Water Purifier',
          description: 'Ideal for multi-use facilities, this purifier offers extensive water purification capacity and substantial intake space.'
        }
      },
      {
        posX: '59.8125rem',
        posY: '7.37rem',
        mobilePosX: '79%',
        mobilePosY: '24%',
        productInfo: {
          image: require('@/assets/images/location/factory/product_img_05.png'),
          name: 'CESCO\nIndoor Insect Light Inceptor',
          description: 'This device controls stray pests entering business premises and also serves an aesthetic function with its compact design.'
        }
      }
    ]
  },

  {
    backgroundImg: require('@/assets/images/location/factory/background_img_05.png'),
    products: [
      {
        posX: '40.875rem',
        posY: '6.87rem',
        mobilePosX: '55%',
        mobilePosY: '23%',
        productInfo: {
          image: require('@/assets/images/location/factory/product_img_03.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      },
      {
        posX: '58.3125rem',
        posY: '21.62rem',
        mobilePosX: '77%',
        mobilePosY: '67%',
        productInfo: {
          image: require('@/assets/images/location/factory/product_img_06.png'),
          name: 'CESCO\nAir IOT Air Purifier SE',
          description: 'Manage air quality intelligently with options customized for your business environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/factory/background_img_06.png'),
    products: [
      {
        posX: '37.9375rem',
        posY: '12.4325rem',
        mobilePosX: '50%',
        mobilePosY: '36%',
        productInfo: {
          image: require('@/assets/images/location/factory/product_img_07.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/factory/background_img_07.png'),
    products: [
      {
        posX: '44.4375rem',
        posY: '8.0575rem',
        mobilePosX: '59%',
        mobilePosY: '25%',
        productInfo: {
          image: require('@/assets/images/location/factory/product_img_08.png'),
          name: 'CESCO\nAirgenic',
          description: 'This automatic air freshener and deodorizer boasts powerful odor neutralization and fragrance release.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}

useMeta({
  title: 'CESCO - Manufacturing Plants',
  meta: [
    {
      name: 'description',
      content: 'Manufacturing Plants. Hygienically manage the manufacturing process to safeguard against pests, viruses, and bacteria.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
